import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React from 'react';
import PropTypes from 'prop-types';
import Box from '../Box';
import Text from '../Text';

var TabBarItemInner =
/*#__PURE__*/
_styled(Box, {
  target: "e1y9t14c0"
})(process.env.NODE_ENV === "production" ? {
  name: "2vihep",
  styles: "background:transparent;text-decoration:none;display:flex;flex-direction:column;border:none;align-items:center;&:focus{outline:none;}"
} : {
  name: "2vihep",
  styles: "background:transparent;text-decoration:none;display:flex;flex-direction:column;border:none;align-items:center;&:focus{outline:none;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9UYWJCYXIvVGFiQmFySXRlbS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNbUMiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL1RhYkJhci9UYWJCYXJJdGVtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgQm94IGZyb20gJy4uL0JveCc7XG5pbXBvcnQgVGV4dCBmcm9tICcuLi9UZXh0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgVGFiQmFySXRlbUlubmVyID0gc3R5bGVkKEJveClgXG4gIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xuICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGJvcmRlcjogbm9uZTtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICAmOmZvY3VzIHtcbiAgICBvdXRsaW5lOiBub25lO1xuICB9XG5gO1xuXG5UYWJCYXJJdGVtSW5uZXIuZGVmYXVsdFByb3BzID0ge1xuICBmb250U2l6ZTogJ3NtYWxsJyxcbiAgY29sb3I6ICd0ZXh0JyxcbiAgcHg6IDEsXG59O1xuXG5jb25zdCBTSVpFUyA9IHtcbiAgRk9OVF9TSVpFOiAndGlueScsXG4gIEZPTlRfTElORV9IRUlHSFQ6ICcxNHB4JyxcbiAgSUNPTl9TSVpFOiAyNCxcbiAgSUNPTl9MSU5FX0hFSUdIVDogMS4zLFxufTtcblxuY29uc3QgVGFiQmFySXRlbSA9ICh7IGljb24sIGxhYmVsLCBpc0FjdGl2ZSwgLi4ucmVzdFByb3BzIH0pID0+IChcbiAgPFRhYkJhckl0ZW1Jbm5lciB7Li4ucmVzdFByb3BzfT5cbiAgICA8Qm94XG4gICAgICBmb250U2l6ZT17U0laRVMuSUNPTl9TSVpFfVxuICAgICAgbGluZUhlaWdodD17U0laRVMuSUNPTl9MSU5FX0hFSUdIVH1cbiAgICAgIGNvbG9yPXtpc0FjdGl2ZSA/ICdwcmltYXJ5JyA6ICdpbmhlcml0J31cbiAgICAgIG1iPXswfVxuICAgID5cbiAgICAgIHtpY29ufVxuICAgIDwvQm94PlxuICAgIDxUZXh0XG4gICAgICBmb250U2l6ZT17U0laRVMuRk9OVF9TSVpFfVxuICAgICAgbGluZUhlaWdodD17U0laRVMuRk9OVF9MSU5FX0hFSUdIVH1cbiAgICAgIGNvbG9yPXtpc0FjdGl2ZSA/ICdwcmltYXJ5JyA6ICdpbmhlcml0J31cbiAgICA+XG4gICAgICB7bGFiZWx9XG4gICAgPC9UZXh0PlxuICA8L1RhYkJhckl0ZW1Jbm5lcj5cbik7XG5cblRhYkJhckl0ZW0ucHJvcFR5cGVzID0ge1xuICBpY29uOiBQcm9wVHlwZXMubm9kZS5pc1JlcXVpcmVkLFxuICBsYWJlbDogUHJvcFR5cGVzLnN0cmluZyxcbiAgaXNBY3RpdmU6IFByb3BUeXBlcy5ib29sLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgVGFiQmFySXRlbTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

TabBarItemInner.defaultProps = {
  fontSize: 'small',
  color: 'text',
  px: 1
};
var SIZES = {
  FONT_SIZE: 'tiny',
  FONT_LINE_HEIGHT: '14px',
  ICON_SIZE: 24,
  ICON_LINE_HEIGHT: 1.3
};

var TabBarItem = function TabBarItem(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      isActive = _ref.isActive,
      restProps = _objectWithoutProperties(_ref, ["icon", "label", "isActive"]);

  return React.createElement(TabBarItemInner, restProps, React.createElement(Box, {
    fontSize: SIZES.ICON_SIZE,
    lineHeight: SIZES.ICON_LINE_HEIGHT,
    color: isActive ? 'primary' : 'inherit',
    mb: 0
  }, icon), React.createElement(Text, {
    fontSize: SIZES.FONT_SIZE,
    lineHeight: SIZES.FONT_LINE_HEIGHT,
    color: isActive ? 'primary' : 'inherit'
  }, label));
};

export default TabBarItem;